// CareerPathTree.js
import React from "react";
import { Box, Typography, Container } from "@mui/material";

const CareerPath = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#000",
        py: { xs: 4, sm: 6, md: 8, lg: 10 },
      }}
    >
      {/* Career Path Title */}
      <Typography
        variant="h2"
        sx={{
          color: "#fff",
          fontFamily: "'SF Pro Display', 'Inter', sans-serif",
          fontWeight: 600,
          fontStyle: "bold",
          fontSize: {
            xs: "28px",
            sm: "36px",
            md: "44px",
            lg: "56px",
          },
          lineHeight: {
            xs: "35px",
            sm: "45px",
            md: "55px",
            lg: "70px",
          },
          textAlign: "center",
          mb: { xs: 3, sm: 4, md: 5, lg: 6 },
          textShadow: "0px 4px 64px rgba(255, 194, 24, 0.3)",
        }}
      >
        Career Path
      </Typography>

      {/* Career Path Image Container */}
      <Box
        component="img"
        src="../../assets/images/career-path.svg"
        alt="career-path"
        sx={{
          width: "100%",
          height: "auto",
          display: { xs: "none", md: "block" }, // Hide on mobile, show on medium and above
        }}
      />

      {/* Mobile Career Path Image */}
      <Box
        component="img"
        src="../../assets/images/career-path-mobile.svg"
        alt="career-path-mobile"
        sx={{
          width: "100%",
          height: "auto",
          display: { xs: "block", md: "none" }, // Show on mobile, hide on medium and above
        }}
      />
    </Box>
  );
};

export default CareerPath;
